import { Link, createFileRoute, redirect } from '@tanstack/react-router'
import { Button } from '@/components/ui/button'
import { auth } from '@/lib/firebase'

export const Route = createFileRoute('/session-timeout')({
  beforeLoad: () => {
    if (auth.currentUser) {
      throw redirect({ to: '/documents' })
    }
  },
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <div className="flex min-h-screen items-center justify-center p-4">
      <div className="bg-card w-full max-w-md rounded-lg border p-6 shadow-sm">
        <h1 className="text-lg font-semibold">Session expired</h1>
        <p className="text-muted-foreground mt-2 text-sm">
          You have been signed out due to inactivity. Please log in again to
          continue.
        </p>
        <Button asChild className="mt-6 w-full">
          <Link to="/login">Log in</Link>
        </Button>
      </div>
    </div>
  )
}
